import { useState } from 'react';
import { navItems } from '@/mocks/home';

const anchors: Record<string, string> = {
  首页: '#top',
  事件始末: '#feed',
  时间线: '#timeline',
  全过程梳理: '#process',
  深度解析: '#deep',
  热度榜: '#rank',
};

export default function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [keyword, setKeyword] = useState('');

  return (
    <header className="sticky top-0 z-40 border-b border-background-200 bg-background-50/95 backdrop-blur">
      <div className="mx-auto flex h-16 max-w-[1400px] items-center justify-between gap-4 px-4 md:h-20 md:px-6">
        <a href="#top" className="flex shrink-0 cursor-pointer items-center gap-3">
          <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-background-50 md:h-11 md:w-11">
            <i className="ri-eye-2-line text-2xl" />
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg font-black tracking-tight text-foreground-950 md:text-xl">
              黑料爆料
            </span>
            <span className="mt-1 text-[10px] tracking-[0.28em] text-foreground-500">EVENT ARCHIVE</span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 lg:flex">
          {navItems.map((item) => (
            <a
              key={item.label}
              href={anchors[item.label] ?? '#top'}
              className={`relative whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium transition-colors ${
                item.active
                  ? 'text-primary-700'
                  : 'text-foreground-700 hover:bg-background-100 hover:text-foreground-950'
              }`}
            >
              {item.label}
              {item.hot ? (
                <span className="ml-1 inline-flex h-1.5 w-1.5 animate-blip rounded-full bg-accent-500 align-middle" />
              ) : null}
              {item.active ? (
                <span className="absolute inset-x-3 -bottom-px h-0.5 rounded-full bg-primary-500" />
              ) : null}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <div className="hidden items-center gap-2 rounded-md border border-background-300 bg-background-100 pl-3 pr-1 py-1 md:flex">
            <i className="ri-search-line text-base text-foreground-500" />
            <input
              value={keyword}
              onChange={(event) => setKeyword(event.target.value)}
              type="text"
              placeholder="搜索事件 / 关键词"
              className="w-36 bg-transparent py-1.5 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none xl:w-44"
            />
            <button
              type="button"
              className="cursor-pointer whitespace-nowrap rounded bg-primary-500 px-3 py-1.5 text-xs font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              搜索
            </button>
          </div>

          <a
            href="#subscribe"
            className="hidden cursor-pointer items-center gap-1 whitespace-nowrap rounded-md bg-accent-500 px-4 py-2.5 text-sm font-semibold text-foreground-950 transition-colors hover:bg-accent-600 md:inline-flex"
          >
            <i className="ri-notification-3-line text-base" />
            订阅更新
          </a>

          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setMenuOpen((open) => !open)}
            className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-300 bg-background-100 text-foreground-800 lg:hidden"
          >
            <i className={menuOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} />
          </button>
        </div>
      </div>

      {menuOpen ? (
        <div className="border-t border-background-200 bg-background-50 lg:hidden">
          <div className="mx-auto flex max-w-[1400px] flex-col gap-1 px-4 py-4 md:px-6">
            {navItems.map((item) => (
              <a
                key={item.label}
                href={anchors[item.label] ?? '#top'}
                onClick={() => setMenuOpen(false)}
                className={`flex items-center justify-between rounded-md px-3 py-3 text-sm font-medium ${
                  item.active ? 'bg-primary-100 text-primary-700' : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                {item.label}
                <i className="ri-arrow-right-s-line text-lg text-foreground-400" />
              </a>
            ))}
            <div className="mt-2 flex items-center gap-2 rounded-md border border-background-300 bg-background-100 px-3 py-2">
              <i className="ri-search-line text-base text-foreground-500" />
              <input
                type="text"
                placeholder="搜索事件 / 关键词"
                className="w-full bg-transparent py-1 text-sm focus:outline-none"
              />
            </div>
          </div>
        </div>
      ) : null}
    </header>
  );
}